import { API_BASE_URL } from '../../config'
import {
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE
} from './profileActionTypes'

export const updateProfile = (profileData) => async (dispatch, getState) => {
  const token = localStorage.getItem('auth_token')
  const { profile } = getState().profile || {}

  if (!token) {
    dispatch({ type: UPDATE_PROFILE_FAILURE, error: 'No authentication token found' })
    return
  }

  dispatch({ type: UPDATE_PROFILE_REQUEST })

  try {
    // Get the user ID from the profile
    const userId = profile?.id

    if (!userId) {
      throw new Error('User ID not found in profile')
    }

    const res = await fetch(`${API_BASE_URL}/user/profile/${userId}/`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`,
      },
      credentials: 'include',
      body: JSON.stringify(profileData)
    })

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}))
      throw new Error(errorData.detail || errorData.message || 'Failed to update profile')
    }

    const data = await res.json()

    // Dispatch success action with the updated profile data
    dispatch({ type: UPDATE_PROFILE_SUCCESS, payload: data })

    // Fetch the latest profile data to ensure everything is in sync
    await dispatch(fetchProfile())

    return data
  } catch (error) {
    dispatch({
      type: UPDATE_PROFILE_FAILURE,
      error: error.message || 'An error occurred while updating profile'
    })
    throw error
  }
}

export const fetchProfile = () => async (dispatch, getState) => {
  const token = localStorage.getItem('auth_token')

  if (!token) {
    dispatch({ type: FETCH_PROFILE_FAILURE, error: 'No authentication token found' })
    return
  }

  dispatch({ type: FETCH_PROFILE_REQUEST })

  try {
    const res = await fetch(`${API_BASE_URL}/user/profile/me/`, {
      headers: {
        'accept': 'application/json',
        'Authorization': `Token ${token}`,
      },
      credentials: 'include'
    })

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}))
      throw new Error(errorData.detail || 'Failed to fetch profile')
    }

    const data = await res.json()
    dispatch({ type: FETCH_PROFILE_SUCCESS, payload: data })
  } catch (error) {
    dispatch({
      type: FETCH_PROFILE_FAILURE,
      error: error.message || 'An error occurred while fetching profile'
    })
  }
}
